import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import AdSlot300x250 from "@/component/Ads/AdSlot300x250";
import AdSlot728x90 from "@/component/Ads/AdSlot728x90";

import RelatedNews from "@/component/RelatedNews";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import React, { useContext, useEffect, useMemo, useState } from "react";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import GTMScript from "@/component/Ads/GTMScript";
import WebpageSchema from "@/component/SeoTags/WebpageSchema";
import BreadcrumbSchema from "@/component/SeoTags/BreadcrumbSchema";
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
import HeadTag from "@/component/SeoTags/HeadTag";

import CommonFooter from "./CommanFooter";
import TopBanner from "./TopBanner";
import ScheduleComponent from "./ScheduleComponent";
import ShortsSection from "./Shorts";
import MPLiveTV from "./MPLiveTV";
// import UtsavFaqSchema from "@/component/SeoTags/UtsavFaqSchema";
// import EventUtsavSchema from "@/component/SeoTags/EventUtsavSchema";
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));

const LandingPage = ({
  categoryNewsList = null,
  faqData = null,
  isMobileDevice = false,
  photoData = null,
  storyData = null,
  videoData = null,
  electionLiveData = null,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const bihar_baithak = masterConfig["bihar_baithaki"];

  const storiesData =
    storyData?.content ||
    categoryNewsList?.content?.filter((item) => item?.content_type == "story");
  // console.log("stories",categoryNewsList?.content,storiesData)
  const videosData =
    videoData?.content ||
    categoryNewsList?.content?.filter((item) => item?.content_type == "video");
  const photosData =
    photoData?.content ||
    categoryNewsList?.content?.filter(
      (item) => item?.content_type == "photo_gallery"
    );
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: storyData?.seo_detail?.meta_keyword?.split(",") || [],
  };
  // const adKey = masterConfig["master_interstitial"];

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag &&
          googletag?.cmd.push(function () {
            if (!scrolled) {
              googletag.destroySlots();
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434453897-0"
                )
                ?.addService(googletag.pubads());
            }
            if (scrolled) {
              if (storiesData?.length > 0) {
                document.getElementById("div-gpt-ad-1659434604998-0") &&
                  googletag
                    .defineSlot(
                      "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                      [300, 250],
                      "div-gpt-ad-1659434604998-0"
                    )
                    .addService(googletag.pubads());
              }

              document.getElementById("div-gpt-ad-1659435474737-0") &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                    [300, 250],
                    "div-gpt-ad-1659435474737-0"
                  )
                  .addService(googletag.pubads());
            }
            if (!scrolled) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                  [320, 50],
                  "div-gpt-ad-1659435612077-0"
                )
                ?.addService(googletag.pubads());
            }
            // // googletag.pubads().enableSingleRequest();
            // googletag.pubads().disableInitialLoad();
            googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
            googletag.enableServices();
            requestBiddingFromPWT();
            // Object.keys(keyBindings).forEach((key) => {
            //   googletag.pubads().setTargeting(key, keyBindings[key]);
            // });
            !scrolled &&
              googletag.cmd.push(function () {
                var INTERSTITIALAd = googletag
                  .defineOutOfPageSlot(
                    "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                    googletag.enums.OutOfPageFormat.INTERSTITIAL
                  )
                  .addService(googletag.pubads());

                googletag.display(INTERSTITIALAd);
              });
          });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659094777326-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            if (storiesData?.length > 0) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-2"
                )
                .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [scrolled]);

  useEffect(() => {
    const hash = window.location.hash;

    if (hash === "#videos" || hash === "#photos") {
      const element =
        document.getElementById("videos") || document.getElementById("photos");

      if (element) {
        // First scroll element into view
        element.scrollIntoView({ behavior: "smooth", block: "start" });

        setTimeout(() => {
          let offset = 110;
          if (hash === "#videos") {
            offset += 10;
          }
          window.scrollBy({ top: -offset, left: 0, behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  const landingContent = `बिहार Tak विधानसभा चुनाव पर सबसे बड़ी बैठक लेकर आ रहा है. जहां सियासत के सबसे बड़े धुरंधर का महाजुटान होगा. मुख्यमंत्री नीतीश कुमार, नेता प्रतिपक्ष तेजस्वी यादव, केंद्रीय मंत्री नित्यानंद राय, उप-मुख्यमंत्री विजय सिन्हा, कांग्रेस नेता कन्हैया कुमार, जनसुराज के प्रशांत किशोर, और भी कई दिग्गज एक ही मंच पर होंगे. जहां बिहार तक करेगा मुद्दों की बात और पूछे जाएंगे जनता से जुड़े सवाल..विधानसभा चुनाव 2025 से पहले पटना में पॉलिटिक्स का जमघट..`;

  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, []);

  const meta_data = {
    title: `Bihar Tak Baithak 2025: बिहार की राजनीति, समाज और जनता की चर्चा - News Tak`,
    description: `Bihar Tak Baithak 2025: बिहार की राजनीति, समाज और विकास से जुड़ी बड़ी चर्चाएँ। देखें नेताओं, विशेषज्ञों और जनता की आवाज़ एक ही मंच पर.`,
    keywords: `Bihar Tak Baithak 2025, Bihar Tak Baithak, Bihar politics discussion, Bihar Tak Baithak program, Bihar social issues debate, Bihar Tak Baithak today highlights, बिहार तक बैठक, बिहार तक बैठक हाइलाइट्स`,
  };
  const eventSchema = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "बिहार तक बैठक 2025",
    description:
      "बिहार के राजनीतिक और सरकारी अपडेट पर आधारित BiharTak द्वारा आयोजित बैठक। नवीनतम फैसलों, घोषणाओं और चर्चा के लिए जुड़ें।",
    startDate: "2025-09-03T10:00:00+05:30",
    endDate: "2025-09-03T19:00:00+05:30",
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    location: {
      "@type": "Place",
      name: " बैठक",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Hotel Maurya Patna ,Fraser Rd, South Gandhi Maidan",
        addressLocality: "Raja Ji Salai, Dujra Diara, Patna",
        addressRegion: "Bihar",
        postalCode: "800001",
        addressCountry: "IN",
      },
    },
    organizer: {
      "@type": "Organization",
      name: "biharTak",
      url: "https://www.newstak.in/bihar",
    },
    image: bihar_baithak?.desktopBannerUrl,
    url: "https://www.newstak.in/bihar/bihar-tak-baithak",
  };
  return (
    <div>
      <HeadTag
        title={meta_data?.title}
        description={meta_data?.description}
        keywords={meta_data?.keywords}
        canonicalUrl={
          router.asPath.includes("/photos")
            ? process.env.NEXT_PUBLIC_WEBSITE_URL + router.asPath
            : process.env.NEXT_PUBLIC_WEBSITE_URL + "/bihar/bihar-tak-baithak"
        }
        noAuthorTag={false}
        image={bihar_baithak?.desktopBannerUrl}
        lcpImage={`${storyData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript />
      {/* <RichmediaScript isMobile={isMobileDevice} isHome={false}/> */}
      <WebpageSchema
        title={meta_data?.title}
        description={meta_data?.description}
        keywords={meta_data?.keywords}
        canonicalUrl={
          router.asPath.includes("/photos")
            ? process.env.NEXT_PUBLIC_WEBSITE_URL + router.asPath
            : process.env.NEXT_PUBLIC_WEBSITE_URL + "/bihar/bihar-tak-baithak"
        }
      />
      <BreadcrumbSchema breadcrumbList={storyData?.category_detail} />
      <ItemsListSchema data={storyData?.content} />
      <Breadcrumb breadcrumbList={storyData?.category_detail} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(eventSchema) }}
      />

      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659094777326-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>
      {/* <h1 className="hidden">बिहार तक बैठक 2025 (Bihar Tak Baithak 2025)</h1> */}
      <TopBanner masterConfigKey={bihar_baithak} />
      {
        <>
          <div className="hidden md:flex justify-between bg-[#F1F2FA] px-3 py-2 mx-7 my-2 rounded-md">
            <div>
              {" "}
              <h1 className="mt-2.5 text-black font-bold">
                बिहार Tak बैठक 2025
              </h1>{" "}
            </div>
            {bihar_baithak?.showRegistrationForm && (
              <div>
                <a
                  href="/bihar/bihar-tak-baithak/registration"
                  className="bg-[#CF4C9B] hover:bg-[#bb237e] my-1  w-[240px] h-[35px] flex items-center justify-center text-white rounded-md"
                >
                  Register Now
                </a>{" "}
              </div>
            )}
          </div>

          {bihar_baithak?.showRegistrationForm && (
            <div className="block md:hidden  mx-6">
              <a
                href="/bihar/bihar-tak-baithak/registration"
                className="bg-[#CF4C9B] hover:bg-[#bb237e] my-1  w-[100%] h-[35px] flex items-center justify-center text-white rounded-md"
              >
                Register Now
              </a>{" "}
            </div>
          )}
        </>
      }
      {bihar_baithak?.showLiveTV && (
        <div className="top-layer-election" style={{ position: "sticky" }}>
          <MPLiveTV
            electionLiveData={electionLiveData?.content}
            firstActive={firstActive}
          />
        </div>
      )}
      {!bihar_baithak?.showScheduleBelow && (
        <div className="mx-3 my-4">
          {" "}
          {bihar_baithak?.events?.length > 0 && (
            <ScheduleComponent events={bihar_baithak?.events} />
          )}
        </div>
      )}
      <div className="mx-3 my-4">
        {" "}
        {bihar_baithak?.youtubeShorts?.length > 0 && (
          <ShortsSection youtubeShorts={bihar_baithak?.youtubeShorts} />
        )}
      </div>
      <div className="mx-4 my-4">
        <div className="ml-2" id="videos">
          {(videosData?.length > 0 || videosData?.length > 0) && (
            <RelatedNews
              relatedNewsData={videosData}
              customTitle="वीडियो"
              isPhotoGallery={false}
            />
          )}
          <div id="photos">
            {(photosData?.length > 0 || photosData?.length > 0) && (
              <RelatedNews
                relatedNewsData={photosData}
                customTitle="फोटो गैलरी"
                isPhotoGallery={true}
              />
            )}
          </div>
        </div>
        <div className="mx-3 md:mx-4">
          {storiesData?.length > 0 && scrolled && (
            <AdSlot300x250
              divId="div-gpt-ad-1659434604998-0"
              minWidth="300px"
              minHeight="250px"
            />
          )}
          {storiesData?.length > 0 && scrolled && (
            <AdSlot728x90
              divId="div-gpt-ad-1707804176041-2"
              minWidth="728px"
              minHeight="90px"
            />
          )}
        </div>
      </div>
      {
        <div>
          <CommonFooter
            content={landingContent}
            categoryNewsList={storiesData}
            isMobileDevice={false}
            showAds={true}
            scrolled={scrolled}
            showContent={true}
          />
          {bihar_baithak?.showScheduleBelow && (
            <div className="mx-3 my-4">
              {" "}
              {bihar_baithak?.events?.length > 0 && (
                <ScheduleComponent events={bihar_baithak?.events} />
              )}
            </div>
          )}
          {scrolled && (
            <div className="mx-3 md:mx-4">
              <AdSlot300x250
                divId="div-gpt-ad-1659435474737-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
          )}
          {scrolled && (
            <div className="mx-3 md:mx-4">
              <AdSlot728x90
                divId="div-gpt-ad-1659425743360-0"
                minWidth="728px"
                minHeight="90px"
              />
            </div>
          )}
        </div>
      }

      <div className="mx-4">
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </div>
    </div>
  );
};

export default LandingPage;
